import React, { useState, useEffect, Link } from "react";
import axios from 'axios';
import { alert_error, alert_success } from "../../AppContext.js";

const MyTableComponent = () => {
    // Giả lập dữ liệu mẫu, thay vì truy vấn từ cơ sở dữ liệu
    const [id_users, set_id_users] = useState('');
    const [username, set_username] = useState('');
    const [phone, set_phone] = useState('')
    const [chedo, set_chedo] = useState('')
    const [value, set_value] = useState('')
    const [data, set_data] = useState([
        {
            stt: 1,
            name: "Service 1",
            money: "1000",
            id: "123",
            minorder: "10",
            category: "Category 1",
            status: "Active",
        },
        {
            stt: 2,
            name: "Service 2",
            money: "2000",
            id: "124",
            minorder: "20",
            category: "Category 2",
            status: "Inactive",
        },
        // Thêm dữ liệu mẫu ở đây
    ]);
    const fetchData = () => {
        axios.get('https://hust.media/hustadmin_v2/member_list.php?id_users=' + id_users + '&username=' + username + '&phone=' + phone)
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    function testFunction(response) {
        set_data(response.data);
    }
    useEffect(() => {
        fetchData();
    }, []);
    const handleInputChange1 = (event) => {
        set_username(event.target.value); // Cập nhật giá trị của id_users
    };
    const handleInputChange2 = (event) => {
        set_id_users(event.target.value); // Cập nhật giá trị của id_users
    };
    const handleInputChange3 = (event) => {
        set_phone(event.target.value); // Cập nhật giá trị của id_users
    };
    const change_value = (event) => {
        set_value(event.target.value); // Cập nhật giá trị của id_users'

    };
    const member_edit = (event) => {
        event.preventDefault(); // Ngăn trang tải lại
        // Logic để chỉnh sửa thành viên
        console.log("Member edit function called");
        axios.get('https://hust.media/hustadmin_v2/member_edit.php?chedo=' + chedo + '&value=' + value + '&id_users=' + users_edit.id)
            .then((response) => {
                testFunction2(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    function testFunction2(response) {
        alert_success(response.data);
        fetchData();
        closeModal();
    }
    const [isModalVisible, setModalVisible] = useState(false);


    const closeModal = () => setModalVisible(false);
    const openModal = (row) => {
        set_users_edit(row); // Cập nhật giá trị của id_users
        setModalVisible(true);
    };
    const [users_edit, set_users_edit] = useState('');
    const options = [
        { id: 1, name: 'edit_money' },
        { id: 2, name: 'edit_hanmuc' },
        { id: 3, name: 'edit_total_nap' },
        { id: 4, name: 'edit_coin_digital' },
        { id: 5, name: 'edit_money_crypto' },
        { id: 6, name: 'block_user' },
        { id: 7, name: 'un_block_ref' },
        { id: 8, name: 'notification' },
    ];

    const handleChange = (event) => {
        const selectedValue = event.target.value;
        set_chedo(selectedValue);
        console.log(`Selected option: ${selectedValue}`);
    };
    return (

        <div className="card-body mx-2 my-2">
            <div className="flex">
                {!isModalVisible ?
                    (<></>) :
                    (
                        <div className="App">
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                                    <h2 className="text-lg font-semibold mb-2">Chỉnh sửa</h2>
                                    <form onSubmit={member_edit}>
                                        <div className="mb-4">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                                                Username {users_edit.username}
                                            </label>
                                            <select
                                                id="select"
                                                value={chedo}
                                                onChange={handleChange}
                                                className="mb-2 block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                            >
                                                <option value="" disabled>Select an option</option>
                                                {options.map((option) => (
                                                    <option key={option.id} value={option.name}>
                                                        {option.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <input
                                                onChange={change_value} // Gọi hàm handleInputChange khi có thay đổi
                                                value={value}
                                                type="text"
                                                id="value"
                                                placeholder="value"
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                            />
                                        </div>
                                        <div className="flex items-center justify-between">
                                            <button
                                                type="submit"
                                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            >
                                                Submit
                                            </button>
                                            <button
                                                onClick={closeModal}
                                                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )
                }

                <input
                    type="text"
                    placeholder="username"
                    value={username} // Giá trị của input sẽ liên kết với state id_users
                    onChange={handleInputChange1} // Gọi hàm handleInputChange khi có thay đổi
                    onKeyPress={fetchData} // Thêm sự kiện onKeyPress
                />
                <button className="mr-2" onClick={() => fetchData()}>
                    search
                </button>
                <input
                    type="text"
                    placeholder="id_users"
                    value={id_users} // Giá trị của input sẽ liên kết với state id_users
                    onChange={handleInputChange2} // Gọi hàm handleInputChange khi có thay đổi
                    onKeyPress={fetchData} // Thêm sự kiện onKeyPress
                />
                <button className="mr-2" onClick={() => fetchData()}>
                    search
                </button>
                <input
                    type="text"
                    placeholder="phone"
                    value={phone} // Giá trị của input sẽ liên kết với state id_users
                    onChange={handleInputChange3} // Gọi hàm handleInputChange khi có thay đổi
                    onKeyPress={fetchData} // Thêm sự kiện onKeyPress
                />
                <button onClick={() => fetchData()}>
                    search
                </button>
            </div>

            <div className="table-responsive-sm">
                <table className="table-auto w-full border-collapse">
                    <thead>
                        <tr>
                            <th className="border text-center py-2 w-1/12">id_users</th>
                            <th className="border text-center py-2 w-2/12">Username</th>
                            <th className="border text-center py-2 w-1/12">Pass</th>
                            <th className="border text-center py-2 w-2/12">Số dư</th>
                            <th className="border text-center py-2 w-1/12">total_nap</th>
                            <th className="border text-center py-2 w-1/12">name_level</th>
                            <th className="border text-center py-2 w-1/12">hạn mức</th>
                            <th className="border text-center py-2 w-1/12">coin_digital</th>
                            <th className="border text-center py-2 w-1/12">createdate</th>
                            <th className="border text-center py-2 w-1/12">THAO TÁC</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td className="border text-center py-2 break-all">{row.id}</td>
                                <td className="border text-center py-2 break-all"><b>{row.username}</b></td>
                                <td className="border text-center py-2 break-all">{row.password}</td>
                                <td className="border text-center py-2 break-all">{row.money}</td>
                                <td className="border text-center py-2 break-all">{row.total_nap}</td>
                                <td className="border text-center py-2 break-all">{row.name_level}</td>
                                <td className="border text-center py-2 break-all">{row.money3}</td>
                                <td className="border text-center py-2 break-all">{row.coin_digital}</td>
                                <td className="border text-center py-2 break-all">{row.createdate}</td>
                                <td className="border text-center py-2">
                                    <div onClick={() => openModal(row)} href={`edit-dich-vu.php?id=${row.id}`} className="btn btn-default">
                                        <i className="fas fa-edit"></i> Edit
                                    </div>
                                </td>
                                <td className="border text-center py-2">
                                    <a href={`dich-vu.php?delete=${row.id}`} className="btn btn-default">
                                        <i className="fas fa-trash"></i> Delete
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyTableComponent;
